import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudAlertMessagesModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { FreudLoaderModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ServiceEvolutionQualityBanner } from './service-evolution-quality-banner.component';

@NgModule({
	declarations: [ServiceEvolutionQualityBanner],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudAlertMessagesModule,
		FreudTypographyModule,
		FreudLoaderModule,
	],
	exports: [ServiceEvolutionQualityBanner],
	providers: [],
})
export class ServiceEvolutionQualityBannerModule {}
